<template>

	<div class="user_wbox">
		<div class="inter">
			<div class="div1 t-flex">
				<div class="fl">
					<div class="user_ti">个人中心</div>
					<div class="user_menu">
						<div class="item" @click="open(item)" :class="{'active':menu_id == item.id}"
							v-for="(item, index) in menu">
							{{item.name}}
						</div>

					</div>
				</div>
				<div class="fr">
					<div class="user_center" v-if="menu_id == 1">

						<div class="user_de_ti">个人中心</div>

						<div class="user_info t-flex t-flex-items-center">

							<div class="image">
								<img :src="userinfo.avatar">
							</div>
							<div class="text">
								<p class="p1">{{userinfo.nickname}}</p>
								<p class="p2">注册时间:{{ formatTimestamp(userinfo.createtime) }}</p>
							</div>
						</div>
						<div class="nuserfabox">
							<!-- <div class="abox1">
								<a class="a1">
									<div class="ic">
										<img :src="require(`@/assets/image/myfabu.png`)">
									</div>
									<span class="sp1">我发布的账号</span><span class="sp2">3</span>
								</a>
							</div> -->
							<div class="abox2">
								<a class="a2">
									<div class="ic">
										<img :src="require(`@/assets/image/mysc.png`)">
									</div>
									<span class="sp1">我的收藏</span><span class="sp2">1</span>
								</a>
							</div>

						</div>
					</div>

					<div class="user_center" v-if="menu_id == 2">

						<div class="user_de_ti" style="margin-bottom: 30px;">我的收藏</div>

						<div class="user_page_list">
							<ul class="shoucang_list">

								<li @click="$router.push('/goodsdetail?id='+item.ar_id)" v-for="(item, index) in list"
									class="t-flex ">
									<div class="image">
										<img :src="item.image">
									</div>
									<div class="text">
										<p class="p1">{{item.title}}</p>
										<p class="p2">￥{{item.price2}}</p>
									</div>
								</li>
							</ul>

							<div class="page_fenye" v-if="pagination.total > 0">
								<el-pagination background layout="prev, pager, next" :total="pagination.total"
									:page-size="pagination.per_page" @current-change="handleCurrentChange">
								</el-pagination>
							</div>
						</div>

					</div>

					<div class="user_center" v-if="menu_id == 6">

						<div class="user_de_ti" style="margin-bottom: 30px;">提号记录</div>

						<div class="user_page_list">
							<ul class="shoucang_list">



								<li @click="$router.push('/goodsdetail?id='+item.ar_id)" v-for="(item, index) in list"
									class="t-flex ">
									<div class="image">
										<img :src="item.cmsarchives.image">
									</div>
									<div class="text">
										<p class="p1">{{item.cmsarchives.title}}</p>
										<p class="p2" style="margin:5px 0;">￥{{item.amount}}</p>
										<p class="p3" style="font-size: 16px;color: #999;">提号时间:{{item.paytime}}</p>
									</div>
								</li>
							</ul>

							<div class="page_fenye" v-if="pagination.total > 0">
								<el-pagination background layout="prev, pager, next" :total="pagination.total"
									:page-size="pagination.per_page" @current-change="handleCurrentChange">
								</el-pagination>
							</div>
						</div>

					</div>


					<div class="user_center" v-if="menu_id == 4">

						<div class="user_de_ti" style="margin-bottom: 30px;">修改密码</div>

						<div class="edit_pass_word">
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									旧密码
								</div>
								<div class="input">
									<el-input v-model="pass" show-password placeholder="请输入旧密码"></el-input>
								</div>

							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									新密码
								</div>
								<div class="input">
									<el-input v-model="pass1" show-password placeholder="请输入新密码"></el-input>
								</div>
							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									确认新密码
								</div>
								<div class="input">
									<el-input v-model="pass2" show-password placeholder="请确认新密码"></el-input>
								</div>
							</div>
							<div style="padding-top: 20px;">
								<div class="debtn" @click="editPass">确认提交</div>
							</div>

						</div>



					</div>
				</div>
			</div>
		</div>
	</div>

</template>


<script>
	import {
		Notification,
		Message
	} from 'element-ui'
	import moment from 'moment';
	export default {
		data() {
			return {
				list: [],
				content: "",
				active: 0,
				title: "",
				info: {},
				acc: "",
				pass: "",
				pass2: "",
				code: "",
				menu_id: 1,
				menu: [{
						id: 1,
						name: "主页",
						url: "/user"
					},
					{
						id: 2,
						name: "我的收藏",
						url: "/shoucang"
					},
					{
						id: 6,
						name: "我的订单",
						url: "/order"
					},
					{
						id: 4,
						name: "修改密码",
						url: "/editpass"
					},
					{
						id: 5,
						name: "注销",
					}
				],
				page: 1,
				list: [],
				pagination: {
					total: 0,
					per_page: 0,
				},
				pass: "",
				pass1: "",
				pass2: ""

			}
		},
		computed: {
			userinfo() {
				return this.$store.getters.userinfo
			}
		},
		created: function(data) {

			// this.getDetail();


		},
		watch: {
			$route() {

			}
		},
		methods: {
			formatTimestamp(timestamp) {
				return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
			},

			open(item) {

				if (item.id == 5) {



					localStorage.removeItem('usertoken')
					sessionStorage.removeItem('usertoken')
					// localStorage.setItem('path', this.$route.path)
					this.$router.push("/")
				} else {

					this.$router.push(item.url)
				}
			},
			handleCurrentChange(val) {
				this.page = val

				if (this.menu_id == 2) {
					this.getShouCang()
				}
				if (this.menu_id == 6) {
					this.getTihao()
				}
			},
			getShouCang() {
				var that = this
				this.rq.requests.post("api/Wxapp/sc", {
					page: that.page
				}).then(res => {

					that.list = res.data.data
					that.pagination.total = res.data.total
					that.pagination.per_page = res.data.per_page
					that.page++

				}).catch(error => {

				})

			},

			getTihao() {
				var that = this
				this.rq.requests.post("api/Wxapp/tihaolist", {
					page: that.page
				}).then(res => {

					that.list = res.data.data
					that.pagination.total = res.data.total
					that.pagination.per_page = res.data.per_page
					that.page++

				}).catch(error => {

				})

			},


			editPass() {
				var that = this
				this.rq.requests.post("api/Wxapp/editpass", {
					oldpassword: that.pass,
					newpassword: that.pass1,
					renewpassword: that.pass2,
				}).then(res => {

					Message.success({
						message: "修改成功",
						duration: 3000
					})
					localStorage.removeItem('usertoken')
					sessionStorage.removeItem('usertoken')

					setTimeout(function() {
						that.$router.push("/login")

					}, 1000);


				}).catch(error => {

				})

			},




		}


	}
</script>